import { baseApi } from "@/services/api/baseApi";

const starTags = (guid) => [
  { type: "StarredInvoices", id: "LIST" },
  { type: "InvoiceDetail", id: guid },
  { type: "Invoices", id: "LIST" },
  { type: "MyInvoices", id: "LIST" },
];

export const starredApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    starInvoice: builder.mutation({
      query: (invoiceGuid) => ({
        url: "/users/starred-invoices",
        method: "POST",
        body: { invoiceGuid },
      }),
      invalidatesTags: (result, error, arg) => starTags(arg),
    }),

    unstarInvoice: builder.mutation({
      query: (invoiceGuid) => ({
        url: "/users/starred-invoices",
        method: "DELETE",
        body: { invoiceGuid },
      }),
      invalidatesTags: (result, error, arg) => starTags(arg),
    }),
  }),
});

export const { useStarInvoiceMutation, useUnstarInvoiceMutation } = starredApi;
